<template>
  <div class="mpr">
    <!-- <iframe src="http://localhost:9000/index.html?studyId=&token="></iframe> -->
    <iframe style="border: medium none;" :src="'http://localhost:9000/index.html?' + 'studyId=' + ids + '&' + 'token=' + token + '&' + 'index=' + index + '&reloaded=' + 1 "></iframe>
  </div>
</template>

<script>
export default {
  name: "mpr",
  data() {
  
    return {
      ids:'',
      token:'',
      index:'',
    };
  },
  created() {
    this.ids = this.$route.query.userId;
    this.token = this.$route.query.token;
    this.index = this.$route.query.index;
    console.error('123',this.index)
    // this.changeWindow(90,35)
  },
  methods: {
  
  },
};
</script>


<style lang="scss" scoped>
  .mpr {
    width: 100%;
    height: 100vh;
  }
  iframe {
    width: 100%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/mpr/viewer.vue